import { render, staticRenderFns } from "./todoCard.vue?vue&type=template&id=564fee48&scoped=true"
import script from "./todoCard.vue?vue&type=script&lang=js"
export * from "./todoCard.vue?vue&type=script&lang=js"
import style0 from "./todoCard.vue?vue&type=style&index=0&id=564fee48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564fee48",
  null
  
)

export default component.exports